module.exports = __webpack_public_path__ + "home-partner-image-architecture.1eySQ-VY.svg";